import { useQuery } from "@tanstack/react-query";
import { userApi } from "@queries/User";
import queryKeys from "../../constants/queryKeys";

export default function useLastAccessOrganization(enabled = true) {
  return useQuery({
    queryKey: [queryKeys.LAST_ACCESS_ORGANIZATION],
    queryFn: async () => userApi.getLastAccessOrganization(),
    enabled
  });
}
